// deps
import React, { ReactElement, memo, useCallback } from "react";

//interfaces
import { BannerData, BANNER_TYPE } from "@payment-ui/interfaces/PaymentBanner";

// components
import { KYCMediaBannner } from "./components/KYCBanner";
import { ImageMediaBannner } from "./components/ImageBanner";
import { NCEMIBanner } from "./components/NCEMIBanner";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

interface PaymentBannerProps {
    banner: BannerData;
    onClick?: (link: string, type: string, id: string) => void;
    onViewBanner: (banner: BannerData) => void;
    containerClassName?: string;
    bannerDimensions?: { width: number; height: number };
}

const COMPONENT_MAP = {
    [BANNER_TYPE.KYCBANNER]: KYCMediaBannner,
    [BANNER_TYPE.IMAGEBANNER]: ImageMediaBannner,
};

/**
 * Payment Banner use to show kyc, add money banner widgets
 * Use to render `Kyc Banner`, `Swiggy Money wallet creation Banner`
 * @param props
 */
export const PaymentBanner = memo(function PaymentBanner({
    banner,
    onClick,
    onViewBanner,
    containerClassName,
    bannerDimensions,
}: PaymentBannerProps): ReactElement | null {
    const handleClick = useCallback(
        (e: React.MouseEvent): void => {
            e.preventDefault();
            if (!!onClick && !!banner.cta) {
                onClick(banner.cta.link, banner.cta.type, banner.id);
            }
        },
        [onClick, banner.cta, banner.id],
    );

    useEffectOnce(() => {
        onViewBanner(banner);
    });

    let Component = COMPONENT_MAP[banner.bannerType];
    if (banner.id === "nc_emi_banner") {
        Component = NCEMIBanner;
    }
    return (
        <Component
            handleClick={handleClick}
            bannerDimensions={bannerDimensions}
            banner={banner}
            containerClassName={containerClassName}
        />
    );
});
